import ICodeEditorBuiltinLanguage from './ICodeEditorBuiltinLanguage';

export default class CodeEditorBuiltinLanguage implements ICodeEditorBuiltinLanguage {
	id: string;
	extensions: Array<string>;
}
